import React from 'react'

import { FontWeight, Text } from '@gousto-internal/citrus-react'

type RecipeCountProps = {
  label: string
  textColor?: string
}

export const RecipeCount = ({ label, textColor }: RecipeCountProps) => (
  <Text fontWeight={FontWeight.Bold} size={4} style={textColor ? { color: textColor } : undefined}>
    {label}
  </Text>
)
